module.exports = __webpack_public_path__ + "static/media/scrutinity.a0df29c4.svg";